import React, { useEffect, useState } from "react";
import { supabase } from "./supabaseClient";
import Sep10GrowthCommunityLayer from "./Sep10GrowthCommunityLayer";

// The community surface is an admin-only control. Default to hidden so there
// is never a public flash while the current session is being verified.
export default function AdminOnlyCommunityLayer() {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    let active = true;

    const verify = async session => {
      if (!active) return;
      if (!session?.user?.id) {
        setIsAdmin(false);
        return;
      }

      // Hide immediately on every auth transition until the server confirms
      // the current account is the master admin.
      setIsAdmin(false);
      const { data, error } = await supabase.rpc("is_master_admin");
      if (active) setIsAdmin(!error && data === true);
    };

    void supabase.auth.getSession()
      .then(({ data, error }) => {
        if (!active) return;
        if (error) {
          setIsAdmin(false);
          return;
        }
        void verify(data?.session || null);
      })
      .catch(() => {
        if (active) setIsAdmin(false);
      });

    const { data: authListener } = supabase.auth.onAuthStateChange((_event, session) => {
      setIsAdmin(false);
      setTimeout(() => { void verify(session); }, 0);
    });

    return () => {
      active = false;
      authListener?.subscription?.unsubscribe?.();
    };
  }, []);

  if (!isAdmin) return null;
  return <Sep10GrowthCommunityLayer />;
}
